var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from "react";
import styled from "styled-components";
import Container from "../../atoms/Container";
import VerifyFrame from "../../organisms/PaymentPortal/Verify";
// @ts-ignore
import { Fade } from "react-reveal";
import Payoff from "../../molecules/Payoff";
import LanguageToggle from "../../molecules/LanguageToggle";
import LanguageSelector from "../../molecules/LanguageSelector";
import LanguageSelection from "../../atoms/LanguageSelect";
import ClickOutside from "../../organisms/ClickOutside";
// @ts-ignore
import { useMediaQuery } from "react-responsive/src";
import PaymentLogo from "../../atoms/PaymentLogo";
import { getAppThemeName } from "../../../../services/appTheme";
import IdealPage from "../../atoms/IdealPage";
import FooterMenu from "../../molecules/FooterMenu";
const StyledContainer = styled(Container) `

  @media only screen and (max-width: 475px) {
    overflow: hidden;
  }
  @media only screen and (max-width: 576px) {
    width: 100%;
  }
`;
const Desktop = ({ children }) => {
    const isDesktop = useMediaQuery({ minWidth: 992 });
    return isDesktop ? children : null;
};
const Mobile = ({ children }) => {
    const isMobile = useMediaQuery({ maxWidth: 991 });
    return isMobile ? children : null;
};
const Verify = (_a) => {
    var props = __rest(_a, []);
    const [isExpanded, setExpanded] = useState(false);
    return (React.createElement(IdealPage, null,
        React.createElement(StyledContainer, null,
            React.createElement(PaymentLogo, Object.assign({ appTheme: getAppThemeName() }, props)),
            React.createElement(ClickOutside, { onOutside: () => setExpanded(false) },
                React.createElement(LanguageSelection, { isAuthVersion: true, hideOnMobile: true },
                    React.createElement(LanguageToggle, { onClick: () => setExpanded(prevToggle => !prevToggle) }),
                    React.createElement(LanguageSelector, { isExpanded: isExpanded, isReversed: true }))),
            React.createElement(Fade, { bottom: true, distance: "80px", delay: 200 },
                React.createElement(VerifyFrame, Object.assign({}, props))),
            React.createElement(Payoff, { variant: true }),
            React.createElement(Mobile, null,
                React.createElement(FooterMenu, null))),
        React.createElement(Desktop, null,
            React.createElement(FooterMenu, null))));
};
export default Verify;
